// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"942ee884","139":"02a7f8b9","635":"942ee884","745":"40967a7e","802":"942ee884","839":"942ee884","872":"ff9e0370","913":"942ee884"}[chunkId] + ".chunk.css";
};